export default "__VITE_ASSET__DbVm3Acd__"